import { PokerCard } from "./PokerCard";
import { GameState } from "@/types/poker";
import Logo from "@/assets/images/logo.png";

interface PokerTableCenterProps {
  state: GameState;
}

export const PokerTableCenter = ({ state }: PokerTableCenterProps) => {
  const totalPot = state.pot ?? 0;

  return (
    <div className="relative flex h-full flex-col items-center justify-center gap-2 text-white">
      <img src={Logo} alt="SmartPoker Logo" className="absolute inset-0 m-auto h-64 w-64 opacity-15" />
      <div className="relative z-10 flex flex-col items-center justify-center gap-2">
        <div className="rounded-full border border-white/20 bg-black/30 px-4 py-1 text-center text-sm backdrop-blur">
          <div className="text-base font-semibold text-secondary">{totalPot}</div>
        </div>

        <div className="flex items-center gap-1">
          {/* CORRECTED: Use `state.community` instead of `state.communityCards` */}
          {state.community && state.community.length > 0
            ? state.community.map((card, idx) => <PokerCard key={idx} card={card} compact />)
            : null}
        </div>
      </div>
    </div>
  );
};
